import React from "react";

/**
 * MedBridge — boutique medical emblem + serif wordmark.
 * Variants: "light" (on navy) | "dark" (on white) | "compact" (symbol only).
 */
export default function Logo({ variant = "light", compact = false, className = "" }) {
  const textColor = variant === "light" ? "#FFFFFF" : "#0A2342";
  const subColor = variant === "light" ? "rgba(255,255,255,0.55)" : "rgba(10,35,66,0.55)";
  const gold = "#C9A84C";

  return (
    <div
      className={`inline-flex items-center gap-3 ${className}`}
      data-testid="medbridge-logo"
      aria-label="MedBridge"
    >
      {/* Emblem — thin gold oval with serif M monogram & dot accent */}
      <svg
        width="34"
        height="44"
        viewBox="0 0 34 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        className="shrink-0"
      >
        {/* outer oval */}
        <rect
          x="1"
          y="1"
          width="32"
          height="42"
          rx="16"
          stroke={gold}
          strokeWidth="1"
          fill="none"
        />
        {/* inner hairline oval */}
        <rect
          x="3.5"
          y="3.5"
          width="27"
          height="37"
          rx="13.5"
          stroke={gold}
          strokeOpacity="0.35"
          strokeWidth="0.6"
          fill="none"
        />
        {/* Serif-inspired M monogram */}
        <path
          d="M9.5 30 V 15 L 17 24 L 24.5 15 V 30"
          stroke={gold}
          strokeWidth="1.3"
          strokeLinecap="square"
          strokeLinejoin="miter"
          fill="none"
        />
        {/* top-left serif foot */}
        <path d="M8.2 15 H 10.8" stroke={gold} strokeWidth="1.1" />
        {/* top-right serif foot */}
        <path d="M23.2 15 H 25.8" stroke={gold} strokeWidth="1.1" />
        {/* bottom serif feet */}
        <path d="M8.2 30 H 10.8" stroke={gold} strokeWidth="1.1" />
        <path d="M23.2 30 H 25.8" stroke={gold} strokeWidth="1.1" />
        {/* accent dot — subtle medical cross reference */}
        <circle cx="17" cy="36.5" r="1.1" fill={gold} />
      </svg>

      {!compact && (
        <div className="flex flex-col leading-none">
          <span
            className="font-playfair font-medium tracking-[0.01em]"
            style={{
              color: textColor,
              fontSize: "22px",
              letterSpacing: "0.005em",
            }}
          >
            Med<span style={{ color: gold, fontStyle: "italic" }}>B</span>ridge
          </span>
          <span
            className="mt-1.5 font-inter font-medium uppercase"
            style={{
              color: subColor,
              fontSize: "8px",
              letterSpacing: "0.38em",
            }}
          >
            Boutique&nbsp;Medical
          </span>
        </div>
      )}
    </div>
  );
}
